import React from 'react'

const ButtonsComponent = props => {
    const { Renderer } = props

    return <Renderer {...props} />
}

export default ButtonsComponent
